<template>
  <AppWithLoading :fetch="fetchVacancyAndRedirect" />
</template>

<script>
import { mapState } from 'vuex';
import AppWithLoading from '../components/AppWithLoading.vue';

export default {
  name: 'ShortVacancyRedirect',
  components: { AppWithLoading },
  props: {
    vacancyId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState('vacancy', ['vacancy']),
  },
  methods: {
    async fetchVacancyAndRedirect() {
      await this.$store.dispatch('vacancy/fetchVacancy', this.vacancyId);
      await this.$router.push({ name: 'vacancy', params: { vacancyId: this.vacancy?.data?.id, companyId: this.vacancy?.data?.companyId } });
    },
  },
};
</script>

<style scoped>

</style>
